

import { InjectionToken } from '@angular/core';

import { DateLocale, MwcI18nInterface } from './mwc-i18n.interface';

export const NZ_I18N = new InjectionToken<MwcI18nInterface>('mwc-i18n');

/** Locale for date operations, should import from date-fns, see example: https://github.com/date-fns/date-fns/blob/v1.30.1/src/locale/zh_cn/index.js */
export const NZ_DATE_LOCALE = new InjectionToken<DateLocale>('mwc-date-locale');
